import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class grittiZeroCanoneGas {
  public static offerta(): Offerte {
    return {
      Flg_Indicizzato: false,
      Id_Offerta: 206,
      Id_Foritore: 2,
      Id_comodity: 2,
      TipoContratto: 1,
      NomeOfferta: "CANONE ZERO",
      LinkFoto: "./assets/images/offerte-gritti/zerocanone-gas.jpg",
      LinkFotoLarge: "./assets/images/offerte-gritti/zerocanone-gas.jpg",
      LinkFotoMid: "./assets/images/offerte-gritti/zerocanone-gas.jpg",
      LinkFotoSm: "./assets/images/offerte-gritti/zerocanone-gas.jpg",
      LinkFotoCarousel: "./assets/images/offerte-gritti/zerocanone-gas.jpg",
      DescrizioneCarousel: "Che Offerta super",
      DescrizioneNomeOfferta: "PREZZO COMPONENTE ENERGETICA BLOCCATO PER 12 MESI SCONTO CANONE TV -45€ €/anno",
      PromozioneOfferta: "",
      Sezioni: [
        {
          NomeSezione: "VANTAGGI ASSICURATI",
          DescrizioneSezione: "",
          lstPunti: ["0 COSTI DI ATTIVAZIONE", "12 MESI PREZZO FISSO", "0 DEPOSITO CAUZIONALE", "AREA RISERVATA WEB", "ASSISTENZA CLIENTI",]
        },
      ],
      PrezzoEle: 0,
      PrezzoGas: 0.2908,

      TitoloPlus: "VANTAGGI ASSICURATI",
      Plus: ["0 COSTI DI ATTIVAZIONE", "12 MESI PREZZO FISSO", "0 DEPOSITO CAUZIONALE", "AREA RISERVATA WEB", "ASSISTENZA CLIENTI",]
      , schedaconfrontabilitaele:
      {
        tabellaConfrontabilita: []
      }
      , schedaconfrontabilitagas: {
        tabellaConfrontabilita: [
            { zona: 1, consumoannuo: 120, importo: 134.61 }
          , { zona: 1, consumoannuo: 480, importo: 347.17 }
          , { zona: 1, consumoannuo: 700, importo: 472.02 }
          , { zona: 1, consumoannuo: 1400, importo: 869.27 }
          , { zona: 1, consumoannuo: 2000, importo: 1207.98 }
          , { zona: 1, consumoannuo: 5000, importo: 2898.25 }
          , { zona: 2, consumoannuo: 120, importo: 124.86}
          , { zona: 2, consumoannuo: 480, importo: 328.39 }
          , { zona: 2, consumoannuo: 700, importo: 448.07 }
          , { zona: 2, consumoannuo: 1400, importo: 828.87 }
          , { zona: 2, consumoannuo: 2000, importo: 1153.45 }
          , { zona: 2, consumoannuo: 5000, importo: 2772.99 }
          , { zona: 3, consumoannuo: 120, importo: 131.09}
          , { zona: 3, consumoannuo: 480, importo: 345.96 }
          , { zona: 3, consumoannuo: 700, importo: 472.11 }
          , { zona: 3, consumoannuo: 1400, importo: 873.47 }
          , { zona: 3, consumoannuo: 2000, importo: 1215.71 }
          , { zona: 3, consumoannuo: 5000, importo: 2923.66 }
          , { zona: 4, consumoannuo: 120, importo: 126.52 }
          , { zona: 4, consumoannuo: 480, importo: 349.47 }
          , { zona: 4, consumoannuo: 700, importo: 480.09 }
          , { zona: 4, consumoannuo: 1400, importo: 895.69 }
          , { zona: 4, consumoannuo: 2000, importo: 1250.17 }
          , { zona: 4, consumoannuo: 5000, importo: 3019.42 }
          , { zona: 5, consumoannuo: 120, importo: 139.38 }
          , { zona: 5, consumoannuo: 480, importo: 372.50 }
          , { zona: 5, consumoannuo: 700, importo: 508.77 }
          , { zona: 5, consumoannuo: 1400, importo: 942.33 }
          , { zona: 5, consumoannuo: 2000, importo: 1312.26 }
          , { zona: 5, consumoannuo: 5000, importo: 3158.86 }
          , { zona: 6, consumoannuo: 120, importo: 146.52}
          , { zona: 6, consumoannuo: 480, importo: 397.73 }
          , { zona: 6, consumoannuo: 700, importo: 544.05 }
          , { zona: 6, consumoannuo: 1400, importo: 1009.60 }
          , { zona: 6, consumoannuo: 2000, importo: 1407.04 }
          , { zona: 5, consumoannuo: 5000, importo: 3391.34 }]
      }
      , lstModalitaPagamento: ["1", "2"]
      , scontoRid: 0
      , TipoSoglieEle: Soglie.SoglieEle4Fasce()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/grittiZeroCanoneGas.ts